import api from '../api';
import {
  SET_ACTIVE_LOCATIONS_LOCATION_REPORT,
  CLEAR_ACTIVE_TEMPLATE,
  CLEAR_REPORT_LIST_STATE,
  SET_LOAD_MORE_FLAG,
  SET_REPORT_TEMPLATE_CREATION_FORM,
  SET_CURRENT_REPORT_TEMPLATE,
  SET_REPORT_DATA_FROM_SEARCH,
  SET_LOCATION_REPORT_FILTER,
  SET_ASSET_REPORT_FILTER,
  SET_GENERAL_REPORT_FILTER,
  SET_CURRENT_GENERAL_REPORT,
  SET_COMAPRE_FIELDS_DATA,
  SET_REPORT_COMPARED_DATA,
  SET_COMPARE_PRESELECT_DATA,
  SET_REPORT_LIST_FILTER_CRITERIA,
  SET_REPORT_LIST_CREATION_FORM
} from '../constants/reduceConstants';
import { formatDate, enqueueErrorSnackbar, enqueueSuccessSnackbar } from 'helpers/AppHelpers';
import {
  SUCCESS_SAVE_REPORT,
  SUCCESS_SUBMIT_REPORT,
  SUCCESS_CREATE_REPORT_TEMPLATE,
  SUCCESS_UPDATE_REPORT_TEMPLATE,
  SUCCESS_PUBLISH_REPORT_TEMPLATE,
  SUCCESS_DELETE_REPORT_TEMPLATE,
  SUCCESS_DELETE_GENERAL_REPORT
} from '../constants/infoSnackbarData';
import { browserHistory } from '../browserHistory';
import {
  LOCATION_REPORT_LIST_PATH,
  ASSET_REPORT_LIST_PATH,
  GENERAL_REPORT_LIST_PATH,
  REPORT_TEMPLATE_LIST_PATH
} from '../constants/routeConstants';

export const getCreationForm = (q) => (dispatch) =>
  api.reportList
    .getCreationFormApi(q)
    .then((res) => {
      dispatch({ type: SET_REPORT_LIST_CREATION_FORM, payload: res });
      return res;
    })
    .catch((err) => console.log(err));

export const getFilterCriteria = (q) => (dispatch) =>
  api.reportList
    .getFilterCriteriaApi(q)
    .then((res) => {
      dispatch({ type: SET_REPORT_LIST_FILTER_CRITERIA, payload: res });
      return res;
    })
    .catch((err) => console.log(err));

export const getLocationWeather =
  ({ lat, lng, date }) =>
  () => {
    const weatherQuery = {
      windspeed_unit: 'mph',
      temperature_unit: 'fahrenheit',
      current_weather: true,
      latitude: lat,
      longitude: lng,
      daily: ['temperature_2m_max', 'temperature_2m_min', 'windspeed_10m_max', 'weathercode'],
      timezone: 'auto',
      start_date: formatDate(date),
      end_date: formatDate(date)
    };
    return api.reportList
      .getLocationWeatherApi(weatherQuery)
      .then((res) => res)
      .catch((err) => console.log(err));
  };

export const getGeneralPdfResource = (id) => () => {
  return api.reportList
    .getGeneralPdfResourceApi(id)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const getActiveLocationsLocationRepot = (query) => (dispatch) => {
  api.reportList
    .getActiveLocationsListApi(query)
    .then((res) => dispatch({ type: SET_ACTIVE_LOCATIONS_LOCATION_REPORT, payload: res }))
    .catch((err) => console.log(err));
};

export const getLocationsAndProjects = () => () =>
  api.reportList
    .getLocationsAndProjectsApi()
    .then((res) => res)
    .catch((err) => console.log(err));

export const getReportTemplateCreationForm = () => (dispatch) => {
  return api.reportList
    .getReportTemplateCreationFormApi()
    .then((res) => {
      dispatch({ type: SET_REPORT_TEMPLATE_CREATION_FORM, payload: res });
      return true;
    })
    .catch((err) => console.log(err));
};

export const searchReportTemplateByLocationId = (id) => (dispatch) =>
  api.reportList
    .searchReportTemplateByLocationIdApi(id)
    .then((res) => {
      dispatch({ type: SET_REPORT_DATA_FROM_SEARCH, payload: res });
      return res;
    })
    .catch((err) => console.log(err));

export const searchTemplateByAssetId = (id) => () =>
  api.reportList
    .searchTemplateByAssetId(id)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getGeneralReportList = (query) => (dispatch) => {
  return api.reportList
    .getGeneralReportListApi(query)
    .then((res) => {
      dispatch({ type: SET_LOAD_MORE_FLAG, payload: false });
      return res;
    })
    .catch((err) => console.log(err));
};

export const getLastSavedGeneralReport = (data) => () => {
  return api.reportList
    .getLastSavedGeneralReportApi(data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const getSingleGeneralReport = (id, reportType) => (dispatch) =>
  api.reportList
    .getSingleGeneralReportApi(id)
    .then((res) => {
      dispatch({ type: SET_CURRENT_GENERAL_REPORT, payload: res });
      return res;
    })
    .catch((err) => {
      console.log('reportType', reportType);
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      browserHistory.push(getRedirectUrl(reportType));
    });

const getRedirectUrl = (type) => {
  const obj = {
    ['asset']: ASSET_REPORT_LIST_PATH,
    ['location']: LOCATION_REPORT_LIST_PATH,
    ['general']: GENERAL_REPORT_LIST_PATH,
    default: '/'
  };

  return obj[type.toLowerCase()] || obj.default;
};

export const upgradeGeneralReport = (data, options) => (dispatch) => {
  const { type, shouldBlur, includeNotification, sessionId } = options;
  const {
    reportType: { name }
  } = data;
  const redirectUrl = getRedirectUrl(name);

  const successAction = (res) => {
    if (!shouldBlur) {
      enqueueSuccessSnackbar(type === 'save' ? SUCCESS_SAVE_REPORT : SUCCESS_SUBMIT_REPORT);
      browserHistory.push(redirectUrl);
      dispatch({ type: CLEAR_ACTIVE_TEMPLATE });
    }
    return res;
  };
  const errorAction = (err) => {
    const errors = JSON.parse(err.request.response);
    enqueueErrorSnackbar('', errors);
    return errors;
  };

  if (data.id) {
    return api.reportList.updateGeneralReportApi(data, includeNotification, sessionId).then(
      (res) => successAction(res),
      (err) => errorAction(err)
    );
  } else {
    return api.reportList.createGeneralReportApi(data, includeNotification).then(
      (res) => successAction(res),
      (err) => errorAction(err)
    );
  }
};

export const updateReport = (data) => () => {
  return api.reportList.updateReportApi(data).then(
    (res) => res,
    (err) => console.log(err)
  );
};

export const removeGeneralReport = (data, options) => () => {
  const { sessionId } = options;
  const {
    reportType: { name }
  } = data;
  const redirectUrl =
    name === 'Asset'
      ? ASSET_REPORT_LIST_PATH
      : name === 'Location'
      ? LOCATION_REPORT_LIST_PATH
      : name === 'General'
      ? GENERAL_REPORT_LIST_PATH
      : '/';

  return api.reportList.removeGeneralReportApi(data.id, sessionId).then(
    () => {
      enqueueSuccessSnackbar(SUCCESS_DELETE_GENERAL_REPORT);
      browserHistory.push(redirectUrl);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
    }
  );
};

export const getShortedReportTemplates = (query) => () =>
  api.reportList
    .getShortedReportTemplatesApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getReportTemplate = (id) => (dispatch) => {
  api.reportTemplates
    .getTemplateApi(id)
    .then((res) => dispatch({ type: SET_CURRENT_REPORT_TEMPLATE, payload: res }))
    .catch((err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      browserHistory.push(REPORT_TEMPLATE_LIST_PATH);
    });
};

export const checkReportTemplateName = (query) => () => {
  return api.reportList
    .checkReportTemplateNameApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const createReportTemplate = (data) => () => {
  return api.reportList.createReportTemplateApi(data).then(
    (res) => {
      if (res.published) {
        enqueueSuccessSnackbar(SUCCESS_PUBLISH_REPORT_TEMPLATE(res.name));
        browserHistory.push(REPORT_TEMPLATE_LIST_PATH);
      } else {
        enqueueSuccessSnackbar(SUCCESS_CREATE_REPORT_TEMPLATE(res.name));
        return res;
      }
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    }
  );
};

export const updateReportTemplate = (data) => () => {
  return api.reportList.updateReportTemplateApi(data).then(
    (res) => {
      if (res.published) {
        enqueueSuccessSnackbar(SUCCESS_PUBLISH_REPORT_TEMPLATE(res.name));
        browserHistory.push(REPORT_TEMPLATE_LIST_PATH);
      } else {
        enqueueSuccessSnackbar(SUCCESS_UPDATE_REPORT_TEMPLATE(res.name));
        return res;
      }
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    }
  );
};

export const deleteReportTemplate = (id, callback) => () => {
  return api.reportList.deleteReportTemplateApi(id).then(
    () => {
      enqueueSuccessSnackbar(SUCCESS_DELETE_REPORT_TEMPLATE);
      browserHistory.push(REPORT_TEMPLATE_LIST_PATH);
      if (callback) callback();
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
    }
  );
};

export const getCompareFields = (id) => (dispatch) => {
  api.reportList
    .getCompareFieldsApi(id)
    .then((res) => {
      dispatch({ type: SET_COMAPRE_FIELDS_DATA, payload: res });
    })
    .catch((err) => console.log(err));
};

export const getReportComparedData = (data) => (dispatch) => {
  api.reportList
    .getReportComparedDataApi(data)
    .then((res) => {
      dispatch({ type: SET_REPORT_COMPARED_DATA, payload: res });
      dispatch({ type: SET_COMPARE_PRESELECT_DATA, payload: { ...data, pageNumber: 1 } });
    })
    .catch((err) => console.log(err));
};

export const getCompareDataSerialized = (data) => () => {
  return api.reportList
    .getCompareDataSerializedApi(data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const getArchiveResource = (query) => () =>
  api.reportList
    .getArchiveResourceApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getTemplateLocations = (q) => () =>
  api.reportList
    .getTemplateLocationsApi(q)
    .then((res) => res)
    .catch((err) => console.log(err));

export const setLocationReportFilter = (payload) => (dispatch) => {
  dispatch({ type: SET_LOCATION_REPORT_FILTER, payload });
};
export const setAssetReportFilter = (payload) => (dispatch) => {
  dispatch({ type: SET_ASSET_REPORT_FILTER, payload });
};
export const setGeneralReportFilter = (payload) => (dispatch) => {
  dispatch({ type: SET_GENERAL_REPORT_FILTER, payload });
};

export const clearComparePreselectData = () => (dispatch) => {
  dispatch({ type: SET_COMPARE_PRESELECT_DATA, payload: {} });
};

export const clearActiveTemplate = () => (dispatch) => {
  dispatch({ type: CLEAR_ACTIVE_TEMPLATE });
};

export const clearReportListState = () => (dispatch) => {
  dispatch({ type: CLEAR_REPORT_LIST_STATE });
  dispatch({ type: SET_LOAD_MORE_FLAG, payload: false });
};
